/** Display order for entity quick filters (keys match audit registry). */
export const AUDIT_ENTITY_QUICK_FILTER_ORDER = [
  'device',
  'user',
  'location',
  'location_complaint_tat_version',
];

/** Short button labels (pluralized where it reads better in the filter row). */
export const AUDIT_ENTITY_QUICK_LABELS = {
  device: 'Devices',
  user: 'Users',
  location: 'Locations',
  location_complaint_tat_version: 'TAT policy',
};

export const AUDIT_ACTION_TYPE_ORDER = ['CREATE', 'UPDATE', 'DELETE', 'ENABLE', 'DISABLE'];

export const AUDIT_ACTION_QUICK_FILTERS = [
  {
    type: 'action',
    actionType: 'CREATE',
    label: 'Creates',
    title: 'Show create actions',
  },
  {
    type: 'action',
    actionType: 'UPDATE',
    label: 'Updates',
    title: 'Show update actions',
  },
  {
    type: 'action',
    actionType: 'DELETE',
    label: 'Deletes',
    title: 'Show delete actions',
  },
  {
    type: 'action',
    actionType: 'ENABLE',
    label: 'Enable',
    title: 'Show location re-activation (enable) actions',
    superadminOnly: true,
    showLocationBadge: true,
  },
  {
    type: 'action',
    actionType: 'DISABLE',
    label: 'Disable',
    title: 'Show location deactivation (disable) actions',
    superadminOnly: true,
    showLocationBadge: true,
  },
];

export const AUDIT_TIME_QUICK_FILTERS = [
  { type: 'time', days: 7, label: 'Last 7d', title: 'Last 7 days' },
  { type: 'time', days: 30, label: 'Last 30d', title: 'Last 30 days' },
  { type: 'time', days: 90, label: 'Last 90d', title: 'Last 90 days' },
  { type: 'time', days: 365, label: 'Last 365d', title: 'Last 365 days' },
];

export function filterShowsLocationBadge(filter) {
  if (!filter) return false;
  if (filter.showLocationBadge) return true;
  return filter.type === 'entity' && filter.entityKey === 'location_complaint_tat_version';
}

export function formatActionTypesForPill(actionTypes = []) {
  const selected = new Set(actionTypes);
  return AUDIT_ACTION_TYPE_ORDER.filter((type) => selected.has(type));
}

export function selectedActionsIncludeLocationScope(actionTypes = []) {
  return actionTypes.some((type) => type === 'ENABLE' || type === 'DISABLE');
}

export function buildEntityQuickFilters(entities = []) {
  const byKey = Object.fromEntries(entities.map((ent) => [ent.key, ent]));

  return AUDIT_ENTITY_QUICK_FILTER_ORDER.filter((key) => byKey[key]).map((key) => {
    const ent = byKey[key];
    return {
      type: 'entity',
      entityKey: key,
      label: AUDIT_ENTITY_QUICK_LABELS[key] || ent.label,
      title:
        key === 'location_complaint_tat_version'
          ? 'Complaint TAT policy changes per location'
          : `${ent.label} audit records`,
      showLocationBadge: key === 'location_complaint_tat_version',
    };
  });
}

export function buildAuditQuickFilters({ entities = [], isSuperAdmin = false, hasEmployeeId = false }) {
  return [
    {
      type: 'all',
      label: 'All',
      title: 'Default view (clears filters)',
    },
    {
      type: 'actor',
      label: 'My changes',
      title: hasEmployeeId
        ? 'Show only changes made by you'
        : 'Your employee ID is not available for this filter',
      disabled: !hasEmployeeId,
    },
    ...buildEntityQuickFilters(entities),
    ...AUDIT_ACTION_QUICK_FILTERS.filter((f) => !f.superadminOnly || isSuperAdmin),
    ...AUDIT_TIME_QUICK_FILTERS,
  ];
}

export function getQuickFilterKey(filter) {
  if (filter.type === 'entity') return `entity-${filter.entityKey}`;
  if (filter.type === 'action') return `action-${filter.actionType}`;
  if (filter.type === 'time') return `time-${filter.days}`;
  return filter.type;
}
